import { StyleSheet } from 'aphrodite';
import { aceGray, navigation, white } from '../../../../styles/colors';

export const styleSheet = StyleSheet.create({
	actionBar: {
		alignItems: 'center',
		boxSizing: 'border-box',
		display: 'flex',
		marginBottom: '1rem',
	},
	container: {
		flex: 1,
		overflow: 'hidden',
		marginTop: 24,
		marginBottom: 24,
		display: 'flex',
		flexDirection: 'column',
		border: `1px solid ${aceGray}`,
		borderRadius: 8,
	},
	inlineLoadingSpinner: {
		marginTop: 50,
	},
	inProgress: {
		color: '#89C947',
		fontSize: 11,
		fontStyle: 'normal',
		fontWeight: 'normal',
		letterSpacing: '1.1px',
		lineHeight: '15px',
		marginTop: 6,
		textTransform: 'uppercase',
	},
	noneFound: {
		color: navigation,
		letterSpacing: 1.1,
		marginTop: 50,
		textAlign: 'center',
		textTransform: 'uppercase',
	},
	plusOthers: {
		color: '#858585',
		flexBasis: '100%',
		fontSize: 11,
		lineHeight: '15px',
		padding: 10,
		textAlign: 'right',
	},
	tableContainer: {
		flex: 1,
		overflow: 'auto',
		background: white,
	},
});
